// extracted by mini-css-extract-plugin
export var deleteButton = "shopping-list-item-module--delete-button--2owB6";
export var deleteButtonText = "shopping-list-item-module--delete-button-text--kZHrf";
export var detailsButton = "shopping-list-item-module--details-button--Eviwa";
export var dot = "shopping-list-item-module--dot--Wm0EX";
export var item = "shopping-list-item-module--item--6Soit";
export var itemActions = "shopping-list-item-module--item-actions--izOu0";
export var itemHeader = "shopping-list-item-module--item-header--N5VS0";
export var listIcon = "shopping-list-item-module--list-icon--YyZvz";